import React, { createContext, useContext, useState, useEffect } from 'react';

const AppConfigContext = createContext();

export function AppConfigProvider({ children }) {
  const [appName, setAppName] = useState('Watson');

  const fetchAppConfig = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL || '/api';
      const res = await fetch(`${API_URL}/app-config`);
      if (res.ok) {
        const data = await res.json();
        setAppName(data.appName || 'Watson');
      }
    } catch (error) {
      console.error('Error fetching app config:', error);
    }
  };

  useEffect(() => {
    fetchAppConfig();
  }, []);

  useEffect(() => {
    document.title = `${appName} - Asistente Inteligente`;
  }, [appName]);

  return (
    <AppConfigContext.Provider value={{ appName, setAppName, refreshAppConfig: fetchAppConfig }}>
      {children}
    </AppConfigContext.Provider>
  );
}

export function useAppConfig() {
  const context = useContext(AppConfigContext);
  if (!context) {
    throw new Error('useAppConfig must be used within an AppConfigProvider');
  }
  return context;
}
